import type { PreviewEnvironmentManagerRuntime } from '../runtime.js';
import type { BridgePreviewEnvironmentDef } from '../types.js';
import { preparePreviewEnvironmentStart } from './prepare-preview-environment-start.js';
import { runPreviewEnvironmentSpawnImmediate } from './run-preview-environment-spawn-immediate.js';

export function startPreviewEnvironment(
  runtime: PreviewEnvironmentManagerRuntime,
  environmentId: string,
  def: BridgePreviewEnvironmentDef,
): void {
  const prepared = preparePreviewEnvironmentStart(runtime, environmentId, def);
  setImmediate(() => {
    runPreviewEnvironmentSpawnImmediate(runtime, environmentId, prepared);
  });
}
